import {noop} from '@benchling/js-utils';
import {css, StyleSheet} from 'aphrodite';
import React, {useMemo} from 'react';

import StepConfigEditorRouterV2 from 'pipelines/generalized-step-config-editor/editors/StepConfigEditorRouterV2';
import {StepConfigEditorContext} from 'pipelines/generalized-step-config-editor/StepConfigEditorContext';
import {JSONValue} from 'util/Types';

import {useDataLayoutContext} from './DataLayoutContext';
import {
  ConfigFormBlock as ConfigFormBlockType,
  ConfigFormField as ConfigFormFieldType,
} from './DataLayoutTypes';

interface ConfigFormFieldProps {
  configFormField: ConfigFormFieldType;
  layoutPath: Array<string | number>;
}

export function ConfigFormField({
  configFormField: {configDataFrameSpec, ...stepConfigEditorRouterV2Props},
  layoutPath,
}: ConfigFormFieldProps): JSX.Element {
  const {clientId, onEvents} = useDataLayoutContext();

  const contextValue = useMemo(
    () => ({dataFrameSpec: configDataFrameSpec, clientStateId: clientId}),
    [configDataFrameSpec, clientId]
  );

  return (
    <StepConfigEditorContext.Provider value={contextValue}>
      <StepConfigEditorRouterV2
        {...stepConfigEditorRouterV2Props}
        disabled={onEvents == null}
        onChangeConfig={
          onEvents == null
            ? noop
            : (config: JSONValue, path: Array<string>, newValue: JSONValue) => {
                onEvents([{type: 'CONFIG_FORM_FIELD', layoutPath, newValue}]);
              }
        }
      />
    </StepConfigEditorContext.Provider>
  );
}

interface ConfigFormBlockProps {
  block: ConfigFormBlockType;
  layoutPath: Array<string | number>;
}

export default function ConfigFormBlock({
  block: {configFields},
  layoutPath,
}: ConfigFormBlockProps): JSX.Element {
  return (
    <div className={css(styles.configFormBlockContainer)}>
      {configFields.map((configFormField, index) => (
        <ConfigFormField
          key={index}
          configFormField={configFormField}
          layoutPath={[...layoutPath, 'configFields', index]}
        />
      ))}
    </div>
  );
}

const styles = StyleSheet.create({
  configFormBlockContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
});
